// extracted by mini-css-extract-plugin
export default {"wrapper":"CatalogDropdown_wrapper__GrNbb","select":"CatalogDropdown_select__SM1OB","chevron":"CatalogDropdown_chevron__m-+MR"};